import { ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

export function useShareActions(unitName?: string) {
  const showShareMenu = ref(false);
  const { t } = useI18n();

  // Fonction pour fermer le menu de partage
  const handleClickOutside = (event: Event) => {
    const shareContainer = document.querySelector('.shareContainer');
    if (shareContainer && !shareContainer.contains(event.target as Node)) {
      showShareMenu.value = false;
    }
  };

  onMounted(() => {
    // Fermer le menu de partage quand on clique ailleurs
    document.addEventListener('click', handleClickOutside);
  });

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
  });

  function shareOnFacebook() {
    const currentUrl = encodeURIComponent(window.location.href);
    const title = unitName 
      ? encodeURIComponent(t('sharing.facebook.title', { unitName }))
      : encodeURIComponent(t('sharing.facebook.titleDefault'));
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}&quote=${title}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
    showShareMenu.value = false;
  }

  async function copyUrlToClipboard() {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch (err) {
      // Fallback pour les navigateurs plus anciens
      const textArea = document.createElement('textarea');
      textArea.value = window.location.href;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
    showShareMenu.value = false;
  }

  function toggleShareMenu() {
    showShareMenu.value = !showShareMenu.value;
  }

  function shareByEmail() {
    const currentUrl = window.location.href;
    const unitDisplayName = unitName ? unitName : 'Cette unité';
    const subject = encodeURIComponent(t('sharing.email.subject', { unitName: unitDisplayName }));
    const body = encodeURIComponent(t('sharing.email.body', { 
      unitName: unitDisplayName, 
      url: currentUrl 
    }));
    
    const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = mailtoUrl;
    showShareMenu.value = false;
  }

  return {
    showShareMenu,
    shareOnFacebook,
    copyUrlToClipboard,
    toggleShareMenu,
    shareByEmail
  };
}